import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { RANGE_FILTER } from '@as-react/common-types';
import { isEqual, isNullOrUndefined } from '@as-react/common-utils';
import { RangeSlider } from '@as/cotopaxi';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { FilterItemContentRangeFilterInputs } from './FilterItemContentRangeFilterInputs';
import { makeGetActiveFiltersState } from '../../../redux/lister/selectors/ListerSelector';
export const FilterItemContentRangeFilter = ({ filter: { rangeMin = 0, rangeMax = 0, name, filterOn, filterPrefix, filterSuffix, boundaryMin = rangeMin, boundaryMax = rangeMax, filterContentType, }, onFilterItemChange, }) => {
    const [value, setValue] = useState({
        min: Math.floor(rangeMin),
        max: Math.ceil(rangeMax),
    });
    const [displayValue, setDisplayValue] = useState(value);
    const isValueValid = !(isNullOrUndefined(value.max) || isNullOrUndefined(value.min));
    // if there is an undefined property value in value, default to the previous legal one
    const sliderValue = (isValueValid && value) || displayValue;
    const activeFilters = useSelector(makeGetActiveFiltersState());
    const isActive = Boolean(activeFilters && activeFilters[filterOn]);
    useEffect(() => {
        // Only set value when filter is not active
        if (!isActive) {
            setValue({
                min: Math.floor(rangeMin),
                max: Math.ceil(rangeMax),
            });
        }
    }, [rangeMin, rangeMax]);
    const handleChange = (v, finished) => {
        setValue(v);
        if (finished && !isEqual(value, displayValue)) {
            if (!isValueValid) {
                setValue(displayValue);
                return;
            }
            onFilterItemChange({
                filterOn: filterOn,
                filterOnName: name,
                filteredItems: [{ filterKey: v.min.toString() }, { filterKey: v.max.toString() }],
                filterType: RANGE_FILTER,
                filterPrefix: filterPrefix,
                filterSuffix: filterSuffix,
                filterContentType: filterContentType,
            });
            setDisplayValue(value);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(RangeSlider, { id: filterOn, name: filterOn, value: sliderValue, onChange: handleChange, min: boundaryMin, max: boundaryMax }), _jsx(FilterItemContentRangeFilterInputs, { value: value, onChange: handleChange, min: boundaryMin, max: boundaryMax, filterPrefix: filterPrefix, filterSuffix: filterSuffix })] }));
};
